import React from 'react'

import { Progress } from 'antd'

const ProgressBar = ({ uploadPercent, uploadingFileService }) => {
  return uploadingFileService && <Progress percent={uploadPercent} />
}

export default ProgressBar
